import { render, staticRenderFns } from "./field-file-view-input.vue?vue&type=template&id=9392a8c8&scoped=true&"
import script from "./field-file-view-input.vue?vue&type=script&lang=js&"
export * from "./field-file-view-input.vue?vue&type=script&lang=js&"
import style0 from "./field-file-view-input.vue?vue&type=style&index=0&id=9392a8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9392a8c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
